import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./NoDataContainer.css";

export default function NoDataContainer(props) {
  return (
    <Container>
      <Row>
        <Col>
          <div className="no-data-container">
            {props.icon}
            {props.message}
          </div>
        </Col>
      </Row>
    </Container>
  );
}
